import i18n from "@/i18n"

export const STATUS_PENDING = "pending"
export const STATUS_CONFIRMED = "confirmed"
export const STATUS_SEATED = "seated"

export const STATUS_CANCELLED = "cancelled"
export const STATUS_NO_SHOW = "no_show"
export const STATUS_WALK_IN = "walk_in"

export const STATUSES = [
  STATUS_PENDING,
  STATUS_CONFIRMED,
  STATUS_SEATED,
  STATUS_CANCELLED,
  STATUS_NO_SHOW,
  STATUS_WALK_IN,
]
export const STATUS_REMOVED = "removed"

export type ReservationStatus = "pending" | "confirmed" | "seated" | "cancelled" | "no_show" | "walk_in" | "removed"

export const RESERVATION_COLORS = {
  [STATUS_PENDING]: {
    light: "#B3DAFB",
    main: "#7EBEF8",
    dark: "#5AA3E5",
  },
  [STATUS_CONFIRMED]: {
    light: "#6CB5FC",
    main: "#2495F9",
    dark: "#3478B7",
  },
  [STATUS_SEATED]: {
    light: "#8FD9A0",
    main: "#5FC277",
    dark: "#449F53",
  },
  [STATUS_NO_SHOW]: {
    light: "#E5A0A0",
    main: "#D76D6D",
    dark: "#B84D4D",
  },
  [STATUS_CANCELLED]: {
    light: "#BFBFBF",
    main: "#9D9D9D",
    dark: "#7A7A7A",
  },
  [STATUS_REMOVED]: {
    light: "#6B6B6B",
    main: "#3E3E3E",
    dark: "#2A2A2A",
  },
  [STATUS_WALK_IN]: {
    light: "#FFD54F",
    main: "#FFC300",
    dark: "#DAA703",
  },
}

export const STATUS_LABELS = {
  [STATUS_CONFIRMED]: i18n.t("app.reservation.status.confirmed"),
  [STATUS_WALK_IN]: i18n.t("app.reservation.status.walk_in"),
  [STATUS_SEATED]: i18n.t("app.reservation.status.seated"),
  [STATUS_PENDING]: i18n.t("app.reservation.status.pending"),
  [STATUS_NO_SHOW]: i18n.t("app.reservation.status.no_show"),
  [STATUS_CANCELLED]: i18n.t("app.reservation.status.cancelled"),
  [STATUS_REMOVED]: i18n.t("app.reservation.status.removed"),
}
